import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DocumentsLegacyRedux from '../../components/Documents';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import {
  fetchFaqsNotesDocuments,
  deleteFaqsNotesDocuments,
} from 'src/store/actions/faqsNotesDocuments';
import { selectDocuments } from 'src/store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from 'src/store/actions/search';
import { fetchPropertyCounts } from 'src/store/actions/properties';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';
import {
  useDocumentSave,
  UseDocumentSaveReturn,
} from 'src/pages/SharedPageCustomHooks/UseDocumentSave/useDocumentSave';

interface PropertyDocumentsProps {
  property: {
    propertyId: string;
    name: string;
  };
}

const PropertyDocuments = ({ property }: PropertyDocumentsProps) => {
  const user = useSelector(selectAuthenticatedUser);
  const documents = useSelector(selectDocuments);
  const loader = useSelector(selectPRLoader);

  const dispatch = useDispatch();
  const onFetchFaqsNotesDocuments = (propertyId: string, loader: any) =>
    dispatch(fetchFaqsNotesDocuments(propertyId, loader));
  const onDeleteFaqsNotesDocuments = (document: any) =>
    dispatch(deleteFaqsNotesDocuments(document));
  const onSetSearch = (searchData: any) => dispatch(setSearch(searchData));
  const onClearSearch = () => dispatch(clearSearch());
  const onFetchPropertyCounts = (
    propertyId: string,
    userId: string,
    roleName: string
  ) => dispatch(fetchPropertyCounts(propertyId, userId, roleName));

  const { saveDocument }: UseDocumentSaveReturn = useDocumentSave({
    customErrorMessage:
      'Failed to upload this property document. Please try again or contact Juniper support if the issue persists.',
  });

  useEffect(() => {
    onFetchFaqsNotesDocuments(property.propertyId, loader);
    onClearSearch();
  }, []);

  const onSave = async (document: DocumentFormData): Promise<void> => {
    await saveDocument(document, property.propertyId, user.id);
  };

  const handleDeleteFaqsNotesDocuments = async (document: any) => {
    document.Type = 'DOCUMENTS';
    onDeleteFaqsNotesDocuments(document);
    onFetchPropertyCounts(
      property.propertyId,
      user.id,
      user.roles[0].role.name
    );
  };

  // Sort documents.
  const sortDocuments: any =
    documents &&
    documents.length > 0 &&
    documents.sort((a: any, b: any) => {
      const firstDocumentName = a.name?.toUpperCase();
      const secondDocumentName = b.name?.toUpperCase();

      if (firstDocumentName < secondDocumentName) {
        return -1;
      }
      if (firstDocumentName > secondDocumentName) {
        return 1;
      }
      return 0;
    });

  return loader ? (
    <Loader />
  ) : (
    <DocumentsLegacyRedux
      breadcrumb={property.name}
      documents={sortDocuments}
      from={'propertyForm'}
      onSaveDocument={(document: any) => onSave(document)}
      onDeleteDocument={(document: any) =>
        handleDeleteFaqsNotesDocuments(document)
      }
      onSearch={(e: any) => onSetSearch({ documents: e.target.value.trim() })}
      labelName={'Manuals & Documents'}
    />
  );
};

export default PropertyDocuments;
